<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isAdmin()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Manage Grading</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
    <button class="btn btn-primary fa fa-plus" @click="modalOpener('addModal')"> Add Type</button>
		<br><br>
<!-- main row for all icons  -->
<div class="col-md-12">
	<div class="card card-primary card-outline">
		<div class="card-body overflow-auto">
      <img v-if="types==''" src="../images/nodata.svg">
			<datatable style="margin-top:1%;" :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy" v-else>
      	<tbody>
        	<tr v-if="types!=''" v-for="type in types" :key="type.id">
          	<td>{{type.name}}</td>
          	<td>
          		<button class="btn btn-primary fa fa-cog" @click="edit(type)"> Edit</button>
          		<button class="btn btn-primary fa fa-cog" @click="sub(type)"> Subtypes</button>
          	</td>
          </tr>				
        </tbody>
      </datatable>	
    </div>
    <div class="card-footer">
    	<pagination :pagination="pagination"
       	@prev="getTypes(pagination.prevPageUrl)"
        @next="getTypes(pagination.nextPageUrl)"
      ></pagination>
		</div>
	</div>
</div>
<!-- row end -->
    </section>
    <!-- /.content -->

<div class="modal fade" style="display: none; padding-right: 12px;" aria-hidden="true" id="addModal">
   <div class="modal-dialog">
      <div class="modal-content">
         <div class="modal-header">
            <h4 class="modal-title">Add/Modify Type</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
         </div>
         <form @submit.prevent="addType" @keydown="form.onKeydown($event)" role="form">
         <div class="modal-body">
         			<div :class="['form-group', errors.name ? 'has-error' : '']">
              	<label>Name</label>
                <input type="text" name="name" v-model="form.name" class="form-control" placeholder="Enter the Name">
                <span v-if="errors.name" :class="['badge bg-danger']">Enter a valid name.</span>
              </div>
         </div>
         <div class="modal-footer">
         		<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
         		<button type="submit" class="btn btn-primary">Add/Modify</button>
         </div>
         </form>
      </div>
   </div>
</div>
<div class="modal fade" style="display: none; padding-right: 12px;" aria-hidden="true" id="subModal">
   <div class="modal-dialog">
      <div class="modal-content">
         <div class="modal-header">
            <h4 class="modal-title">Manage Subtypes</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
         </div>
         <div class="modal-body">
         		<input type="text" v-model="subtype" placeholder="Enter subtype">
         		<button class="btn btn-primary fa fa-plus" @click="addSubType"> Add</button>
         		<table class="table table-striped">
  						<thead>
    						<tr>
      						<th scope="col">Subtype</th>
      						<th scope="col">Manage</th>
      					</tr>
  						</thead>
  						<tbody>
    						<tr v-for="type in subtypes" :key="type.id">
      						<td>{{type.name}}</td>
      						<td>
      							<button class="btn btn-danger fa fa-cog" @click="template(type.name)"> Rows</button>
      						</td>
    						</tr>
    					</tbody>
    				</table>
         </div>
         <div class="modal-footer">
         		<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
         </div>
      </div>
   </div>
</div>

<div class="modal fade" style="display: none; padding-right: 12px;" aria-hidden="true" id="templateModal">
   <div class="modal-dialog">
      <div class="modal-content">
         <div class="modal-header">
            <h4 class="modal-title">Manage Rows</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
         </div>
         <div class="modal-body">
         		<input type="text" v-model="rowtemplate" placeholder="Enter row">
         		<button class="btn btn-primary fa fa-plus" @click="addTemplate"> Add</button>
         		<table class="table table-striped">
  						<thead>
    						<tr>
      						<th scope="col">Row</th>
      						<th scope="col">Manage</th>
      					</tr>
  						</thead>
  						<tbody>
    						<tr v-for="template in templates" :key="template.id">
      						<td>{{template.row_name}}</td>
      						<td>
      						
      						</td>
    						</tr>
    					</tbody>
    				</table>
         </div>
         <div class="modal-footer">
         		<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
         </div>
      </div>
   </div>
</div>
    <br>
      <br>
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isAdmin()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		import Datatable from '../datatable.vue';
    import Pagination from '../pagination.vue';
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        components: {datatable:Datatable, pagination:Pagination},
        
        
        created(){
        	this.getTypes();
        },
        
    		data(){
        	let sortOrders = {};
      		let columns = [
      			{width:'20%', label:'Type', name:'name'},
      			{width:'20%', label: 'Manage', name:'ops'}
      		];
      		columns.forEach((column) => {
          	sortOrders[column.name]=-1;
        	});
        	return{
        		columns: columns,
        		sortKey: 'id',
        		sortOrders: sortOrders,
        		tableData: {
        			draw: 0,
        			length: 10,
        			column: 0,
        			dir: 'desc'
        		},
        		pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
         		form: new Form({
         			name: '',
         			id: ''
         		}),
         		types: [],
         		errors: [],
         		subtypes: [],
         		type: '',
         		subtype: '',
         		rowtemplate: '',
         		templates: []
         }
       },
       
       methods: {
       	configPagination(data){
      		this.pagination.lastPage=data.lastPage;
         	this.pagination.currentPage=data.current_page;
    	  	this.pagination.total=data.total;
        	this.pagination.lastPageUrl=data.last_page_url;
       		this.pagination.nextPageUrl=data.next_page_url;
       		this.pagination.prevPageUrl=data.prev_page_url;
     		 	this.pagination.from=data.from;
        	this.pagination.to=data.to;
    		},
  
      	sortBy(key){
     			this.sortKey=key;
      		this.sortOrders[key] = this.sortOrders[key]*-1;
       	  this.tableData.column = this.getIndex(this.columns, 'name', key);
 	     	  this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
    		},
     		
     		getIndex(array, key, value){
       		return array.findIndex(i => i[key] == value)
       	},
       	
       	getTypes(url="/api/getTypes"){
       		axios.post(url, {params: this.tableData})
       		.then(response => {
       			this.types = response.data.data.data;
       			this.configPagination(response.data.data);
       		})
       	},
        	
        modalOpener(id){
        	this.form.reset();
        	$("#"+id).modal("show");
        },
        
        addType(){
        	this.form.post("/api/addType")
        	.then(response => {
        		this.getTypes();
        	})
        },
        
        edit(type){
        	this.form.fill(type);
        	$("#addModal").modal("show");grade
        },
        
        sub(type){
        	this.subtype = '';
        	this.type = type.name;
        	this.getSubTypes();
        	$("#subModal").modal("show");
        },
        
        getSubTypes(){
        	axios.post("/api/getSubTypes", {type: this.type})
        	.then(response => {
        		this.subtypes = response.data;
        	})
        },
        
        addSubType(){
        	axios.post("/api/addSubType", {name: this.subtype, type: this.type})
        	.then(response => {
        		this.getSubTypes();
        	})
        },
        
        template(type){
        	this.subtype = type;
        	this.getTemplates();
        	$("#templateModal").modal("show");
        },
        
        getTemplates(){
        	axios.post("/api/getTemplates", {type: this.subtype})
        	.then(response => {
        		this.templates = response.data;
        	})
        },
        
        addTemplate(){
        	axios.post("/api/addTemplate", {name: this.rowtemplate, type: this.subtype})
        	.then(response => {
        		this.getTemplates();
        	})
        }
      }
    }
</script>
